import React from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import { localized } from 'decorators'
import { formatters } from 'components/dashboard'
import { useStyles } from './index.css'

export const TotalTableFooter = localized(({ totalCount, totalPrice, localize }) => {
  const classes = useStyles()

  return (
    <TableFooter>
      <TableRow>
        <TableCell>{localize('dashboard.totals')}</TableCell>
        <TableCell align='right' className={classes.count}>{formatters(localize).bottles(totalCount)}</TableCell>
        <TableCell  align='right' className={classes.price}>{formatters(localize).prices(totalPrice)}</TableCell>
      </TableRow>
    </TableFooter>
  )
})
